import cloneDeep from 'lodash/cloneDeep';
import { QueryBuilder } from 'vet-bones/utils/queryBuilder';

import { Model, ModelData } from 'src/containers/ProjectDiagram/types/model';
import { setDataProperty } from 'src/containers/ProjectDiagram/utils/setDataProperty';

const updateQueryBuilderIris =
  (prevIri: string, newIri: string) => (rule: QueryBuilder) => {
    rule.data.query.expressions.forEach((subExpression) =>
      subExpression.expressions.forEach((expression) =>
        expression.filters.forEach((filter) => {
          const { subject, operator, value } = filter;
          if (subject && subject.iri === prevIri) {
            subject.iri = newIri;
          }

          if (operator && operator.iri === prevIri) {
            operator.iri = newIri;
          }

          if (value && typeof value === 'object' && value.iri === prevIri) {
            value.iri = newIri;
          }
        })
      )
    );
  };

export const updateRuleIris =
  (prevIri: string, newIri: string) => (model: Model) => {
    // check if attribute is in any sensitive property groups
    const rulesById = cloneDeep(model.modelData.rulesById);
    const updateQueryBuilder = updateQueryBuilderIris(prevIri, newIri);
    Object.values(rulesById).forEach((rule) => {
      if (rule.ifClause) {
        updateQueryBuilder(rule.ifClause);
      }
      if (rule.thenClause) {
        updateQueryBuilder(rule.thenClause);
      }
    });

    setDataProperty<ModelData>(model)(model.modelData, 'rulesById', rulesById);
  };
